<template>
  <div class="bg_gray" style="padding-bottom:13px">
    <Header navTitle="课程详情" navPath="/mobile/course/list" :hasRightContent="cur.state == 3 && cur.final_price > 0 && cur.discount_count > 0" :rightHandler="getCoupons">
      <template #navRightContent>
        <van-tag color="#fee7e8" text-color="#f74e52" size="large" round class="get_coupons_btn"><i class="iconfont icon-quan"></i>领取优惠</van-tag>
      </template>
    </Header>
    <div class="container intro">
      <div class="cover">
        <img :src="cur.cover_image" />
        <span class="hot" v-if="cur.cover_image_label && cur.cover_image_label != 'null'">{{ cur.cover_image_label }}</span>
        <span class="tag" v-if="cur.type">{{ cur.type }}</span>
      </div>
      <h1>{{ cur.name }}</h1>
      <div class="info">
        <span v-if="cur.start_at">开始时间：{{ cur.start_at }}</span>
        <span v-if="cur.end_at">结束时间：{{ cur.end_at }}</span>
        <span>难度：{{ cur.difficulty_alias }}</span>
        <span v-if="cur.city">地点：{{ cur.city }}</span>
      </div>
      <div class="desc">{{ cur.description }}</div>
      <van-divider />
      <div class="action">
        <span><i class="iconfont icon-icon_huaban1"></i>{{view_num}}</span>
        <span :class="{ 'pointer': true, 'active': courseInfo.good.selected, 'disabled': is_like_disabled}"><i class="iconfont icon-icon-02" @click="actionHandler(0)"></i>{{ courseInfo.good.num }}</span>
        <span :class="{ 'pointer': true, 'active': courseInfo.collection.selected, 'disabled': is_like_disabled}"><i class="iconfont icon-icon-03" @click="actionHandler(1)"></i>{{ courseInfo.collection.num }}</span>
        <span><i class="iconfont icon-icon_huaban12" @click="getQRCode"></i></span>
        <van-overlay :show="showShare" @click="showShare = false" z-index="1000">
          <div class="overlay_wrapper">
            <div class="share" @click.stop>
                <span>扫码分享</span>
                <div class="ecodePop" style="text-align: center ; margin-top: 10px;">
                  <img ref="myQRCode" :src="qrCodeUrl" style="width: 100px; height: 100px;"/>
                </div>
                <van-divider :dashed="true" :style="{borderColor:'#666'}" />
                <van-button type="primary" size="small" :data-clipboard-text="URL" @click="copyPromoCode">复制网址</van-button>
            </div>
          </div>
        </van-overlay>
      </div>
    </div>
    <!-- 主内容 -->
    <div class="container content" ref="courseDetailContent">
      <van-tabs
        ref="courseDetailTabs"
        v-model:active="tabActiveName"
        color="#009dd9"
        title-active-color="#00ADEF"
        line-width="60"
        class="tab_common"
        @click-tab="clickTabHandler">
        <van-tab title="课程介绍" name="intro" v-if="cur.introduce">
          <div class="cur_intro ueditor_style">
            <div v-html="cur.introduce" class="ueditor_content"></div>
          </div>
        </van-tab>
        <van-tab title="教学大纲" name="syllabus" v-if="cur.outline">
          <div v-html="cur.outline" class="ueditor_style ueditor_content"></div>
        </van-tab>
        <van-tab title="讲师简介" name="teachers" v-if="teacherList.length > 0">
          <ul class="teacher_list">
            <li v-for="item in teacherList">
              <div class="top">
                <img :src="item.picture">
                <div class="info">
                  <div class="wrap">
                    <span class="name">{{item.name}}</span>
                    <span class="job">{{item.title}}</span>
                  </div>
                </div>
              </div>
              <div class="bottom">{{item.profile}}</div>
            </li>
          </ul>
        </van-tab>
        <van-tab title="课程内容" name="chapter" v-if="chapter.length > 0">
          <DetailChapter :curUuid="uuid" :chapter="chapter" :video_trial_time="cur.video_trial_time" :video_trial_num="cur.video_trial_num"
                               :canStudy="canStudy" @messageShow="messageShow"  :curType="cur.type" @login="login" @curTypeChange="changeCurType"></DetailChapter>
        </van-tab>
        <van-tab name="discount" v-if="cur.state == 3 && cur.final_price > 0 && cur.discount_count > 0">
          <template #title>
            <span>领取优惠 <i class="iconfont icon-huo hot" style="font-size: 12px;color: #F51C21;position: relative;top: -1px;"></i></span>
          </template>
          <DetailDiscount :cur_uuid="uuid" v-bind="$attrs"></DetailDiscount>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 价格等相关信息 -->
    <div class="sheet_fixed_bottom">
      <div class="price">
        <span class="discount" v-if="cur.final_price != 0">
          <span>¥</span>{{ cur.final_price }}
        </span>
        <span class="free" v-else>免费</span>
        <span class="original" v-if="cur.mark_price">¥ {{ cur.mark_price }}</span>
      </div>
      <!-- 报名后 -->
      <div class="btns" v-if="canStudy">
        <van-button type="primary" size="small" v-if="cur.course_num > 0 && cur.other_class_num != 0" @click="startStudy">进入学习</van-button>
        <van-button type="primary" size="small" plain v-if="cur.question_num > 0" @click="startExercise">进入做题</van-button>
        <!-- 更多按钮 -->
        <van-button size="small" plain @click="showBtns=true" v-if="btnActions.length!==0">更多</van-button>
        <!-- 更多按钮-弹出面板 -->
        <van-action-sheet
          v-model:show="showBtns"
          :actions="btnActions"
          cancel-text="关闭"
          close-on-click-action
        />
      </div>
      <!-- 报名前 -->
      <div class="btns" v-else-if="cur.state == 3">
        <!-- 付费课程 -->
        <div v-if="cur.final_price != 0">
            <!--用户逾期失效-->
            <span v-if="order_stats.expired_count > 0">
              <van-button type="primary" size="small" @click="" disabled>进入学习</van-button>
            </span>
            <!--############################ 购买课程相关按钮 ############################-->
            <!-- 报名额满 -->
            <span v-if="cur.people_num !=0 && order_stats.effective_count >= cur.people_num">
                <van-button type="danger" size="small" plain @click="" disabled>报名额满</van-button>
            </span>

           <!--用户逾期失效-->
           <span v-else-if="order_stats.expired_count > 0">

                 <van-button type="danger" size="small" v-if="order_stats.uncashed.order_count > 0"
                             @click="goPath('/mobile/center/order')">报名待收款</van-button>

                 <van-button type="danger" size="small" v-else-if="order_stats.unpay.order_count > 0"
                             @click="goPayUnPayOrder">报名待支付</van-button>

                 <van-button type="primary" size="small" v-else
                             plain @click="buyImmediately('curriculum', uuid)">重新报名</van-button>
           </span>

            <!-- 未报名 -->
            <span v-else-if="order_stats.unpay.order_count == 0 && order_stats.uncashed.order_count == 0">
              <van-button type="danger" size="small" @click="buyImmediately('curriculum', uuid)">立即报名</van-button>
              <van-button type="danger" size="small" plain :disabled="cur.cart_added" @click="addCart">
                <span v-if="cur.cart_added">已加入购物车</span>
                <span v-else>加入购物车</span>
              </van-button>
            </span>

            <!-- 有下单未支付 -->
            <span v-else>
              <van-button type="danger" size="small" v-if="order_stats.uncashed.order_count > 0"
                 @click="goPath('/mobile/center/order')">报名待收款</van-button>
              <van-button type="danger" size="small" v-else-if="order_stats.unpay.order_count > 0"
                         @click="goPayUnPayOrder">报名待支付</van-button>
            </span>
        </div>
      </div>
    </div>

    <!-- 用户信息 -->
    <van-popup v-model:show="userModal.user_message" position="right" :style="{ width: '100%', height: '100%' }">
      <van-nav-bar z-index="10" left-arrow title="完善个人信息" @click-left="cancel_message"></van-nav-bar>
        <van-form ref="infoForm">
          <van-cell-group>
            <van-cell title-style="font-weight:bold" title="&#160;&#160;&#160;&#160;&#160;&#160;请如实填写您的个人信息，以保证您的正常学习！" />
            <van-field
              v-model="userModal.userList.realname"
              name="work_place"
              label="姓名"
              :formatter="formatter1"
              placeholder="请输入姓名"
              :rules="rules.realname"
            />
            <van-field name="job" label="职业">
              <template #input>
                <van-radio-group v-model="userModal.userList.job" direction="horizontal">
                  <van-radio name="office">职员</van-radio>
                  <van-radio name="student">学生</van-radio>
                  <van-radio name="teacher">教师</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="userModal.userList.work_place"
              name="work_place"
              :formatter="formatter1"
              label="单位/学校"
              placeholder="请输入单位/学校"
              :rules="rules.work_place"
            />
            <van-field
              v-model="userModal.userList.job_name"
              name="job_name"
              :formatter="formatter1"
              label="岗位/专业"
              placeholder="请输入岗位/专业"
              :rules="rules.job_name"
            />
          </van-cell-group>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit" @click="submitForm('infoForm')">
              保存
            </van-button>
          </div>
        </van-form>
    </van-popup>

  </div>
</template>
<script>
  import Header from 'components/mobile/common/Header'
  import DetailChapter from 'components/mobile/course/DetailChapter'
  import DetailDiscount from 'components/mobile/course/DetailDiscount'
  import { get, like, unlike, get_favor_like } from "api/course/course/create"
  import { GetUserState, LoginUser } from 'api/user/auth/login'
  import { addPath, checkPromoCode, checkMessage } from 'api/promoter/selectPromo'
  import { showMessage, showNotify } from 'api/base/mobile/message'
  import { setCookie, getCookie } from 'api/base/axios'
  import { addCurToCart } from 'api/settlement/cart/user'
  import { getCurByCate, getCurOrderState,  getCurDetail } from "api/course/course/detail"
  import { prepareOrder } from 'api/settlement/order/user'
  import { fillOrderStatesDistributedInfo } from 'api/settlement/stats/admin'
  import { checkLogin } from "api/course/course/study"
  import { updateUserInfo } from 'api/user/user/user'
  import { checkExpt, deleteExpt,createUserRecord } from "api/experiment/list"
  import { checkUserCanStudy } from 'api/course/course/list'
  // import Header from "../common/Header";
export default {
  name: 'CurDetail',
    components: {
      Header,
      DetailChapter,
      DetailDiscount,
    },
    props: {
      cur_uuid: String
    },
    inject: ['reload'],
    data() {
      let checkInput = (value, rule) => {
        return new Promise(resolve => {
            if (value.length > 50){
                resolve('字符长度限制在1到50个字符以内')
            }else {
                resolve(true)
            }
        })
      }

      let checkInputLengthRule = (value, rule) => {
        console.log(value)
        if(value.length >= 50){
          return '字符长度限制在1到50个字符以内';
        }
        let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
        if(iconRule2.test(value)){
          return "不能包含表情符号"
        }
        return true;

      }

      return {
        showBtns: false,
        btnActions: [],
        detailTabOffsetTop: 0,
        activeIndex: 0,
        showShare: false,
        uuid: this.cur_uuid,
        qrCodeUrl: null,
        cur_order_loaded:false,
        is_zone_user:false,
        show: false, //false的时候消失遮罩层
        imgUrl: ""  ,
        view_num: 0,
        canStudy: false,
        orderCount: 0,
        userModal:{
          user_id:'',
          user_message:false,
          userList:{
            realname:'',
            job:'office',
            work_place:'',
            job_name:''
          }
        },
        like_check: false,
        is_like_disabled: true,
        cur: {
          name: '',
          description: '',
          difficulty_alias: '',
          cover_image: '',
          cover_image_label: '',
          auth_num: 0,
          face_num: 0,
          video_num: 0,
          live_num: 0,
          people_num: 0,
          teacher_num : 0,
          course_ware_num: 0,
          question_num: 0,
          total_question_num: 0,
          class: '',
          type: '',
          final_price: '',
          mark_price: '',
          start_at: '',
          end_at: '',
          city: '',
          introduce: '',
          outline: '',
          video_trial_time: 0,
          video_trial_num: 0,
          discount_count:0,
          cart_added: false
        },
        order_stats: {
          unpay_order: null,
          expired_count:0,
          effective_count:0,
          unpay: {order_count: 0},
          canceled: {},
          uncashed: {order_count: 0},
          payed: {},
          closed: {},
        },
        chapter: [],
        sharePop: false,
        suffixIsScroll: false,
        courseInfo: {
          good: {
            selected: false,
            num: 0,
          },
          collection: {
            selected: false,
            num: 0,
          }
        },
        tabActiveName: 'intro',
        courseItem: [],
        user:{
            is_authenticated: false,
            user_id: null,
            user_name: null
        },
        options:{
          margin:0,
          width:100,
          height:100
        },
        message:window.location.href,
        teacherList: [],
        promo_code:'',

        rules: {
          job_name: [
            { required: true, message: '请输入岗位/专业', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          work_place: [
            { required: true, message: '请输入学校/单位', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ],
          realname: [
            { required: true, message: '请输入姓名', trigger: 'onBlur' },
            { validator: checkInput, trigger: 'onBlur' },
            { required: true, validator: checkInputLengthRule, trigger: 'onBlur' },
          ]
        }
      }
    },
  mounted() {
    this.$emit('update:isShowHeader', false);

    if(this.uuid){
      this.getCurData()
      this.getCurDetail()
    }
    this.savePromoCode()

    if(this._isMobile()) {
      if (window.location.href.indexOf('mobile') == -1){
          window.location.href = window.location.href.replace(/course/g,"mobile/course")
      }
    }else{
      if (window.location.href.indexOf('mobile') != -1){
          window.location.href = window.location.href.replace(/mobile\//g,"")
      }
    }
    this.getuserId()
  },
  methods: {
    getuserId(){
      GetUserState().then((res) => {
        this.userModal.user_id = res.id
      })
    },
    formatter1(value) {
        // 过滤空格
        return value.replace(/^ +| +$/g, '');
    },
    getBtns() {
      let btnName;
      //报名额满
      if(this.cur.auth_num > 0 && this.cur.people_num !==0 && this.order_stats.effective_count >= this.cur.people_num) {
        this.btnActions.push({
          name: '报名额满',
          disabled: true
        })
      } else if(this.cur.state === 3 && this.cur.final_price !== 0) {
        //没有下单
        if(this.order_stats.unpay.order_count === 0 && this.order_stats.uncashed.order_count === 0 && this.is_zone_user != true) {
          if(this.cur.auth_num > 0) {
            this.btnActions.push({
              name: '再次报名',
              color: '#666',
              callback: ()=>{
                this.buyImmediately('curriculum', this.uuid)
              }
            })
            if(this.cur.cart_added) {
              btnName = '已加入购物车';
            } else {
              btnName = '加入购物车'
            }
            this.btnActions.push({
              name: btnName,
              color: this.cur.cart_added ? '' : '#666',
              disabled: this.cur.cart_added,
              callback:()=>{
                  this.addCart()
              }
            })
          }
        } else {  // 有下单未支付
          if(this.order_stats.uncashed.order_count > 0) {
            this.btnActions.push({
              name: '报名待收款',
              callback:()=>{
                this.goPath('/mobile/center/order/');
              }
            })
          } else if(this.order_stats.unpay.order_count > 0) {
            this.btnActions.push({
              name: '报名待支付',
              callback:()=>{
                this.goPayUnPayOrder()
              }
            })
          }
        }

      }
    },
    clickTabHandler() {
      setTimeout(()=>{
        const detailTabOffsetTop = this.$refs.courseDetailContent.offsetTop - 60;
        window.scrollTo({
          top: detailTabOffsetTop,
          behavior: "smooth"
        });
      }, 500)

    },
    getCurData() {
      if(this.uuid === '' || this.uuid === undefined || this.uuid === 'undefined'){
        return false;
      }
      let data = {'need_info': false}
      get(this.uuid, data).then(res => {
        if(res.code == 0) {
          var data = res.data
          this.cur.name = data.name
          this.cur.description = data.description
          this.cur.difficulty_alias = data.difficulty_alias
          this.cur.cover_image = data.cover_image
          this.cur.cover_image_label = data.cover_image_label
          this.cur.people_num = data.people_num
          this.cur.final_price = data.final_price
          this.cur.mark_price = data.mark_price
          this.cur.introduce = data.introduce.replace(/(.+)/g, ' <p>$1</p>')
          this.cur.outline = data.outline
          this.cur.video_trial_time = data.video_trial_time
          this.cur.video_trial_num = data.video_trial_num
          this.cur.state = data.state
          if(data.state != 3 && data.final_price == 0){
            this.canStudy = false
            this.cur_order_loaded = true
          }
          else if(data.final_price == 0){
            this.canStudy = true
            this.cur_order_loaded = true
          }
          else {
            this.getCurOrder()
          }
          document.title = `${ this.cur.name }-未来网络学堂`;

          //reload 7moor js
          const s = document.createElement('script');
          s.type = 'text/JavaScript';
          s.src = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=a4c3d330-5dcc-11ea-b7ff-07dd5ece4b95&autoShow=true&language=ZHCN';
          document.body.appendChild(s);
        }
      })
    },
    async getCurDetail() {
      const that = this
      await getCurDetail(this.cur_uuid).then(res => {
        if(res.code == 0){
          var data = res.data
          this.cur.auth_num = data.auth_num
          this.cur.face_num = data.face_num
          this.cur.video_num = data.video_num
          this.cur.live_num = data.live_num
          this.cur.course_num = data.auth_num + data.face_num + data.video_num + data.live_num  + data.experiment_num
          this.cur.other_class_num = data.auth_num + data.face_num + data.video_num + data.live_num
          this.cur.course_ware_num = data.course_ware_num
          this.cur.question_num = data.question_num
          this.cur.total_question_num = data.total_question_num
          this.cur.teacher_num = data.teachers.length
          this.teacherList = data.teachers
          this.cur.start_at = data.start_at ? data.start_at.split(' ')[0] : ''
          this.cur.end_at = data.end_at ? data.end_at.split(' ')[0] : ''
          this.cur.city = data.city
          this.cur.discount_count = data.discount_count
          this.cur.cart_added = data.cart_added
          var course_num = 0
          for(var i=0; i<data.cur_chapter.length; i++){
            course_num += data.cur_chapter[i].chapter_content.length
          }
          this.cur.class = data.cur_chapter.length + '章' + course_num + '节'
          var include_types = []
          if(data.auth_num > 0){
            include_types.push('认证码')
          }
          if(data.face_num > 0){
            include_types.push('面授课')
          }
          if(data.live_num > 0){
            include_types.push('直播课')
          }
          if(data.experiment_num > 0){
            include_types.push('实验课')
          }
          if(data.video_num > 0){
            include_types.push('视频课')
          }
          if (include_types.length == 1){
            this.cur.type = include_types[0]
          }
          else if(include_types.length > 1) {
            this.cur.type = '组合课'
          }
          else {
            this.cur.type = ''
          }
          if(data.introduce || data.teachers.length > 0){
            this.tabActiveName = 'intro'
          }
          else if(data.outline) {
            this.tabActiveName = 'syllabus'
          }
          else if(data.cur_chapter.length > 0){
            this.tabActiveName = 'chapter'
          }
          else{
            this.tabActiveName = 'discount'
          }
          this.chapter = data.cur_chapter
          this.getRelatedCur(data.categories)
          this.is_favor_like()
          this.chapter = data.cur_chapter

          this.getBtns()
        }
      })
    },
    getFavorLike(courseItem){
      courseItem.forEach(item => {
        get_favor_like(item.uuid).then(res => {
          item.like = res.like.num
          item.favor = res.favor.num
          item.view = res.view_num
        })
      })
    },
    getCurOrder(){
      const that = this
      return getCurOrderState(this.uuid).then(res => {
        if(res.code == 0) {
          that.canStudy = res.can_study
          this.is_zone_user = res.is_zone_user
          this.orderCount = res.order_count

          let stats_distribute = fillOrderStatesDistributedInfo(res.states_distribution);

          that.order_stats.effective_count = res.effective_count;
          that.order_stats.expired_count = res.expired_count;
          that.order_stats.unpay_order = res.unpay_order;

           stats_distribute.data.forEach(item=>{
//             console.log(item.state)
            switch (parseInt(item.state)) {
              case 1 : { //待支付
                that.order_stats.unpay = item;
              } break;
              case 2 : { //已取消
                that.order_stats.canceled = item;
              } break;
              case 3 : { //待收款
                that.order_stats.uncashed = item;
              } break;
              case 4 : { //已支付
                that.order_stats.payed = item;
              } break;
              case 5 : { //已关闭
                that.order_stats.closed = item;
              } break;
            }

//            console.log(that.order_stats);


          });
           that.cur_order_loaded = true;
        }
      })
    },
    goPayUnPayOrder(){
        this.goPath(`/mobile/order/pay/${this.order_stats.unpay_order.uuid}`);
    },
    getRelatedCur(categories){
      const that = this
      let category_lv1_ids = []
      let category_lv2_ids = []
      for(let i=0; i<categories.length; i++){
        category_lv2_ids.push(categories[i].id)
        category_lv1_ids.push(categories[i].category_lv1_id)
      }
      let filters = {
        category_lv1_ids: category_lv1_ids.join(','),
        category_lv2_ids: category_lv2_ids.join(','),
        exclude_uuid: that.uuid
      }
      getCurByCate(filters).then(res => {
        that.courseItem = res.data

        that.getFavorLike(that.courseItem)
      }).catch(err => {
        showMessage('获取推荐课程失败')
      })
    },
    is_favor_like(){
      get_favor_like(this.uuid).then(res => {
        if(res.like.is_true){
          this.courseInfo.good.selected = true
        }else{
          this.courseInfo.good.selected = false
        }
        if(res.favor.is_true){
          this.courseInfo.collection.selected = true
        }else{
          this.courseInfo.collection.selected = false
        }
        this.courseInfo.good.num = res.like.num
        this.courseInfo.collection.num = res.favor.num
        this.view_num = res.view_num
        this.is_like_disabled = false
      })
    },
    actionHandler(type) {
      let that = this
      if(this.like_check){
        return
      }else{
        this.like_check = true
      }
      if(type === 0) {
        if(this.courseInfo.good.selected) {
          unlike({'target_uuid': this.uuid, 'target_type': 'like'}).then(res => {
            if (res.hasOwnProperty("error") && res.error === 'Not Login') {
                that.$emit('update:loginVisible', true)
            }else{
              that.courseInfo.good.num--
              that.courseInfo.good.selected = !that.courseInfo.good.selected;
              that.like_check = false
            }
          })
        } else {

          like({'target_uuid': this.uuid, 'target_type': 'like'}).then(res => {
            if (res.hasOwnProperty("error") && res.error === 'Not Login') {
                that.$emit('update:loginVisible', true)
            }else{
              that.courseInfo.good.num++
              that.courseInfo.good.selected = !that.courseInfo.good.selected;
              that.like_check = false
            }
          })
        }
      }
      if(type === 1) {
        if(this.courseInfo.collection.selected) {
          unlike({'target_uuid': this.uuid, 'target_type': 'favor'}).then(res => {
            if (res.hasOwnProperty("error") && res.error === 'Not Login') {
                that.$emit('update:loginVisible', true)
            }else{
              that.courseInfo.collection.num--;
              that.courseInfo.collection.selected = !that.courseInfo.collection.selected;
              that.like_check = false
            }
          })
        } else {
          like({'target_uuid': this.uuid, 'target_type': 'favor'}).then(res => {
            if (res.hasOwnProperty("error") && res.error === 'Not Login') {
                that.$emit('update:loginVisible', true)
            }else{
              that.courseInfo.collection.num++
              that.courseInfo.collection.selected = !that.courseInfo.collection.selected;
              that.like_check = false
            }
          })
        }
      }
    },

    async startStudy(){
      await checkMessage().then((res) => {
        if (res.data == 0) {

          let is_logined = false;

          GetUserState().then(result => {
            console.log(result)
            if (result.id == undefined) {
              this.$emit('update:loginVisible', true);
            } else {
              is_logined = true;
            }
            if (is_logined) {
              for(var j=0;j<=this.chapter.length-1;j++){
                let data_course = this.chapter[j].chapter_content
                for(var i=0;i<=data_course.length-1;i++) {
                  if (data_course[i].video_uuid) {
                    this.create_user_record('video',data_course[i].video_uuid)
                    return
                  }
                  else if (data_course[i].live_uuid) {
                    this.create_user_record('live',data_course[i].live_uuid)
                    return
                  }
                  else if (data_course[i].authentication_uuid) {
                    this.create_user_record('authentication',data_course[i].authentication_uuid)
                    return
                  }
                  else if (data_course[i].face_uuid) {
                    this.create_user_record('face_teaching',data_course[i].face_uuid)
                    return
                  }
                }
              }

            }
          }).catch(err => {
            console.log(err);
          });
        }else {
            this.userModal.userList.realname = res.user.realname
            this.userModal.userList.job_name = res.user.job_name
            if (res.user.job != null){
              this.userModal.userList.job = res.user.job
            }else{
              this.userModal.userList.job = 'office'
            }
            this.userModal.userList.work_place = res.user.work_place
            this.userModal.user_message = true
          }
      })
    },
    create_user_record(type,uuid){
        var record_data = {'curr_uuid':this.uuid,'type':type,'uuid':uuid}
        createUserRecord(record_data).then((res) => {
            this.goPath(`/mobile/course/detail/${type}/${this.uuid}/${uuid}`)
        })
    },
    async startExercise() {
      const { code: canStudy } = await checkUserCanStudy({'cur_uuid': this.uuid})
      if(!canStudy) {
        this.reload()
        return
      }

      checkMessage().then((res) => {
        if (res.data == 0) {
          checkLogin().then(res => {
            if (res.code == 1) {
              this.login()
            }
            else {
              this.goPath('/mobile/course/exercise/' + this.uuid)
            }
          })
        }else{
            this.userModal.userList.realname = res.user.realname
            this.userModal.userList.job_name = res.user.job_name
            if (res.user.job != null){
              this.userModal.userList.job = res.user.job
            }else{
              this.userModal.userList.job = 'office'
            }
            this.userModal.userList.work_place = res.user.work_place
            this.userModal.user_message = true
        }
      })
    },
    goCur(path) {
      let domain = document.location.origin
      let url = domain + path
      window.open(url, "_blank");
    },
    goPath(path) {
      this.$router.push(path)
    },
    selectPromo(){
      GetUserState().then((res) => {
        if (res.id) {
          this.user.user_id = res.id
          var select_id = {
              'user_id': this.user.user_id,
              'status': 0
          }
        }
        addPath(select_id).then((res) =>  {
          if (res.data != ''){
//            this.$router.replace( "?" + res.data)
            this.promo_code = res.data
//            var promo_code = res.data
//            setCookie('promo_code', promo_code, )
          }
        })
      })
    },
    savePromoCode(){

//      let code = window.location.href.split('?')[1]
      let s = window.location.href

      var a = s.indexOf("?");
      var b = s.indexOf("=", a);
      if(b === -1){
        var code = s.substr(a+1,16);
      }else{
        var code = s.slice(a+1,b);
      }

      if (a != -1 && code !== undefined){
        let filters = {'promo_codes': code,
                        'status': '0'}
        checkPromoCode(filters).then((res) => {
            if (res.data == 0){
              setCookie('promo_code', code, 3600)
              this.selectPromo()
            }else {
              setCookie('promo_code', '', 3600)
              this.selectPromo()
            }
        })
      }else{
        var old_code = getCookie('promo_code')
        let filters = {'promo_codes': old_code,
                        'status': '0'}
        checkPromoCode(filters).then((res) => {
            if (res.data == 0){
              setCookie('promo_code', old_code, 3600)
              this.selectPromo()
            }else {
              setCookie('promo_code', '', 3600)
              this.selectPromo()
            }
        })
      }
    },
    addCart(){
      addCurToCart(this.uuid).then(result=>{
        if (result.succeed) {
          showNotify('加入购物车成功', 'success')
          this.$emit('update:cartItemCount', result.item_count);
          this.cur.cart_added = true;
        } else {

          switch (result.error_code) {
            case -9999: {
              this.$emit('update:loginVisible', true);
            }
              break;
            default: {
              showNotify(result.error_msg, 'warning')
            }
              break;
          }

        }
      }).catch(err => {
        showNotify(err, 'warning')
      });
    },
    async buyImmediately(type, res_uuid){

      const that = this;
      checkMessage().then((res) => {
        if(res.data == 0) {
          prepareOrder([{
            type: type,
            res_uuid: res_uuid
          }]).then(result => {

            if (result.succeed) {
              that.goPath(`/mobile/order/confirm/${result.confirm_key}`);
            } else {

              switch (result.error_code) {
                case -9999: {
                  this.$emit('update:loginVisible', true);
                }
                  break;
                default: {
                  showNotify(result.error_msg, 'warning')
                }
                  break;
              }

            }

          }).catch(err => {
            showMessage(err)
          });
        }else{
            this.userModal.userList.realname = res.user.realname
            this.userModal.userList.job_name = res.user.job_name
            if (res.user.job != null){
              this.userModal.userList.job = res.user.job
            }else{
              this.userModal.userList.job = 'office'
            }
            this.userModal.userList.work_place = res.user.work_place
            this.userModal.user_message = true
        }

      })

    },
//    copyPromoCode() {
//      var oInput = document.createElement("input") //创建隐形input
//      oInput.value = window.location.href + '?' + this.promo_code // window.location.href 浏览器URL
//      document.body.appendChild(oInput)
//      oInput.select()
//      document.execCommand("Copy")
//      oInput.remove()
//      showMessage('课程链接已经复制到粘贴板','success');
//    },


    // 复制文字
    copyPromoCode(){
      // 数字没有 .length 不能执行selectText 需要转化成字符串
      var text = window.location.href + '?' + this.promo_code
      const textString = text.toString();
      let input = document.querySelector('#copy-input');
      if (!input) {
        input = document.createElement('input');
        input.id = "copy-input";
        input.readOnly = "readOnly";        // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input)
      }

      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      console.log(document.execCommand('copy'), 'execCommand');
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        showMessage('课程链接已经复制到粘贴板','success');
      }
      input.blur();

      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {//ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart('character', startIndex);//起始光标
          range.moveEnd('character', stopIndex - startIndex);//结束光标
          range.select();//不兼容苹果
        } else {//firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }
    },
    getQRCode(){
      this.showShare = true;
      this.message = window.location.href + '?' + this.promo_code
      this.qrCodeUrl = `/api/promoter/share/qrcode/?data=${encodeURIComponent(this.message)}`;
    },
    login() {
      this.$emit('update:loginVisible', true)
    },
    changeCurType(curType){
      this.cur.type = curType
    },
    updateUserInfoMethod(data) {
        updateUserInfo(this.userModal.user_id, data)
          .then((res) => {
            this.loading = false;
            if (res.result === 0) {
              this.$router.go(0);
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
          }).catch((err) => {
          this.loading = false;
          this.$alert('服务异常，请稍后再试', '提示', {
                confirmButtonText: '确定',
          });
        })
      },
    messageShow() {
        this.userModal.user_message = true
    },
    submitForm(formName) {
        this.$refs[formName].validate().then(() => {
            this.updateUserInfoMethod({"job": this.userModal.userList.job, "job_name": this.userModal.userList.job_name, "work_place": this.userModal.userList.work_place, "realname": this.userModal.userList.realname});
        });
    },
    cancel_message() {
        this.userModal.user_message = false
    },

    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    getCoupons() {
      this.tabActiveName = 'discount'
    }
  },
  watch: {
    tabActiveName (val) {
      this.clickTabHandler()
    },
    'cur_uuid' (val) {
      this.uuid = val
      this.getCurData()
      this.getCurDetail()
    },
    '$route' (to, from) {
      if(to.name === 'CourseDetail'){
        this.uuid = to.params.uuid
        this.getCurData()
        this.getCurDetail()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "~@/assets/css/ueditor.scss";
</style>

<style lang="scss" scoped>
  .container {
    background:#fff;
    &.intro {
      padding-top:0;
      margin-bottom:10px;
      .cover {
        position:relative;
        margin-bottom:10px;
        > img {
          display:block;
          width:100%;
          height:100%;
        }
        .hot {
          display:block;
          padding: 5px 20px 5px 10px;
          background: linear-gradient(to right, #f51e22 , #ff7350);
          border-right:1px solid #fff;
          border-bottom:1px solid #fff;
          border-bottom-right-radius: 30px;
          color:#fff;
          position:absolute;
          top:0;
          left:0;
          font-size:12px;
        }
        .tag {
          display:block;
          padding:5px 15px;
          background:rgba(0,0,0,0.5);
          color:#fff;
          position:absolute;
          bottom:10px;
          right:10px;
          font-size:12px;
        }
      }
      h1 {
        font-size:16px;
        color:#333;
        margin-top:0;
        margin-bottom:10px;
        line-height: 1.5;
      }
      .info {
        font-size:12px;
        color:#999;
        margin-bottom:10px;
        line-height:1.5;
        > span {
          margin-right:10px;
        }
      }
      .desc {
        word-break: break-word;
      }
      .action {
         > span {
           padding-left:18px;
           border-left:1px solid #d3d3d3;
           margin-left:18px;
           color:#aaa;
           &:first-child {
              padding-left:0;
              border-left:none;
              margin-left:0;
           }
           i {
              margin-right:7px;
              color:#aaa;
           }
           &.pointer {
             i {
               cursor: pointer;
               &:hover {
                 color: #777777;
               }
             }
             &.active {
               i {
                 color: #09b0ef;
               }
             }
           }
         }
      }
    }
    &.content {
      :deep(.tab_common) {
        .van-tabs__wrap {
          margin: -15px -15px 15px -15px;
        }
        .van-tab {
          padding:0;
        }
      }
      .teacher_list {
        li {
          padding: 10px;
          background: #f9fafc;
          margin-bottom: 10px;
          .top {
            display:flex;
            margin-bottom:10px;
            > img {
              display:block;
              width:80px;
              height:80px;
              margin-right:15px;
            }
            .info {
              flex:1;
              position:relative;
              .wrap {
                position: absolute;
                left: 0;
                right:0;
                top: 50%;
                transform: translateY(-50%);
                word-break: break-word;
                > span {
                  &.name {
                    font-size:16px;
                    font-weight:bold;
                    color:#333;
                    margin-right:10px;
                  }
                  &.job {
                    font-size:12px;
                  }
                }
              }
            }
          }
          .bottom {
            color: #999;
            line-height: 1.5;
          }
        }
      }
    }
  }
  .share {
    width:180px;
    padding:10px;
    border-radius:4px;
    text-align: center;
    background:#fff;
    img, span {
        display:block;
    }
    img {
        margin:0 auto 10px;
    }
  }
  .sheet_fixed_bottom {
    height:70px;
    display:flex;
    align-items: center;
    padding:15px;
    .price {
      flex:1;
      > span {
        vertical-align: middle;
        &.discount {
          font-family: 'font-540';
          font-size:32px;
          color:#f51c21;
          margin-right:10px;
          > span {
            margin-right:10px;
            font-size:18px;
          }
        }
        &.original {
          color:#999;
          font-size:14px;
          text-decoration: line-through;
        }
        &.free {
          font-family: 'font-pingfang-bold';
          font-size:24px;
          font-weight:bold;
          color:#f51c21;
          margin-right:15px;
        }
      }
    }
    .btns {
      button {
        margin-left:10px;
      }
    }
  }
  :deep(.get_coupons_btn) {
    font-size:12px;
    i {
      margin-right:5px;
    }
  }
</style>
